/*
 * @Author: your name
 * @Date: 2021-02-19 19:10:19
 * @LastEditTime: 2021-07-22 10:50:38
 * @LastEditors: zhengfan
 * @Description: In User Settings Edit
 * @FilePath: /castle-black/src/constants/mapForTable.js
 */
import { ADMIN, LEADER, STAFF } from './constants'

export const mapForTable = {
    LOG:'日志',
    ALERT:'警报',
    FAULT:'故障',
    1:'是',
    0:'否',
}

export const loginMap = {
    changePassword:'修改密码',
    signOut:'退出',
    failedNote:'登录名或密码错误，登录失败'
}

export const USER_ROLE_MAP = {
    [ADMIN]:'管理员',
    [LEADER]:'领导',
    [STAFF]:'职员'
};

export const salesRankTab = {
    teamRank:'部门排名',
    personalRank: '个人排名'
}

export const modeMap = {
    AirFreshMode: '等离子模式',
    AtomizerMode: '双氧水模式',
    UvMode: '紫外线模式',
    UvAndAtomizerMode: '双模式'
}